module.exports = __webpack_public_path__ + "img/0-lg.6c28f816.jpg";